import { settingListOptions, type AppSettingList, type SettingListOption } from '@peles/shared';

/** The choices of an active settings list; none if it is missing, inactive or malformed. */
export function readSettingList(
  lists: readonly AppSettingList[],
  listCode: string,
): SettingListOption[] {
  const list = lists.find((l) => l.listCode === listCode && l.isActive);
  return list ? settingListOptions(list.items) : [];
}
